import debug from 'debug';
import { queryString } from 'Global/Shared/Components/QueryString/QueryString';
import Authentication from 'Minetilbud/Shared/Components/Authentication/Authentication';
import favoriteIcon from 'Minetilbud/Shared/Icons/icon_filter_favorite.svg';
import Favorites from '../data/favorites';
import Templates from '../templates/filter-templates';
import FilterBase from './filter-base';

const log = debug('Search:Render:FilterFavorites');
const authentication = new Authentication();
const templates = new Templates();

class FilterFavorites extends FilterBase {
	constructor(element) {
		super(element);
	}

	async getData() {
		const favorites = new Favorites();
		const favoriteCustomerIds = [];

		try {
			if (authentication.Authenticated()) {
				await favorites.get();

				for (const customer of Favorites.dataset) {
					favoriteCustomerIds.push(customer.customerid);
				}
			} 
		} catch (error) {
			log('favorites.get() - ERROR', error);
		}

		const parameter = queryString.Get('favorites')
		const favoritesSelected = parameter !== undefined && parameter.indexOf(favoriteCustomerIds[0]) > -1 ? true : false;

		const options = [
			{
				disabled: !authentication.Authenticated(),
				event: 'single',
				icon: favoriteIcon,
				title: templates.getDictionaryText('filter.sortingFavourites'),
				selected: favoritesSelected,
				value: favoriteCustomerIds.join('|')
			}
		];

		this.options = options;

		return options;
	}

	async render() {
		const dictionary = await templates.initDictionary();
		const items = await this.getData();

		this.setClassName('filter-favorites');

		this.element.insertAdjacentHTML('beforeend', templates.optionsContainer({
			baseClass: this.className,
			boxCss: 'm-filter--light-grey',
			items,
			order: 3,
			urlParameter: 'favorites'
		}));

		super.render();
	}
}

export default FilterFavorites;
